import { Skeleton } from "primereact/skeleton";
import { useMemo } from "react";

function ResumoEscalas({ lista, loading }) {

    const resumo = useMemo(() => {

        const totalOcupacao = lista.reduce(
            (acc, item) => acc + (item.ocupacao || 0),
            0
        );

        const totalVolume = lista.reduce(
            (acc, item) => acc + (item.volume || 0),
            0
        );

        const totalEntregas = lista.reduce(
            (acc, item) => acc + (item.totalEntregas || 0),
            0
        );

        const totalCubos = lista.reduce(
            (acc, item) => acc + (item.cubos || 0),
            0
        );

        const quantidadeCargas = lista.length;

        const mediaOcupacao = totalOcupacao / quantidadeCargas;

        const dropCubo =
            totalCubos > 0
                ? (totalCubos / totalEntregas).toFixed(2)
                : 0;

        return {
            totalEntregas,
            totalCubos,
            quantidadeCargas,
            dropCubo,
            totalVolume,
            mediaOcupacao
        };

    }, [lista]);

    return (
        <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">

            <CardResumo
                titulo="Cargas"
                valor={resumo.quantidadeCargas}
                loading={loading}
                icon="fa fa-truck"
                destaque
            />

            <CardResumo
                titulo="Entregas"
                valor={resumo.totalEntregas}
                loading={loading}
                icon="fa fa-location-dot"
            />

            <CardResumo
                titulo="Volume"
                valor={resumo.totalVolume?.toFixed(2)}
                loading={loading}
                icon="fa fa-box"
            />

            <CardResumo
                titulo="Cubos"
                valor={resumo.totalCubos?.toFixed(2)}
                loading={loading}
                icon="fa fa-cube"
            />

            <CardResumo
                titulo="Ocupação"
                valor={
                    resumo.mediaOcupacao
                        ? resumo.mediaOcupacao.toFixed(2) + "%"
                        : null
                }
                loading={loading}
                icon="fa fa-chart-pie"
            />

            <CardResumo
                titulo="Drop Cubo"
                valor={resumo.dropCubo}
                loading={loading}
                icon="fa fa-chart-line"
            />

            <CardResumo
                titulo="Drop UC"
                loading={loading}
                icon="fa fa-arrow-down-short-wide"
            />

            <CardResumo
                titulo="Cubagem Média"
                loading={loading}
                valor={
                    resumo.quantidadeCargas
                        ? (
                            resumo.totalCubos /
                            resumo.quantidadeCargas
                        ).toFixed(2)
                        : null
                }
                icon="fa fa-calculator"
            />

            <CardResumo
                titulo="Fator UC"
                loading={loading}
                valor={resumo.quantidadeCargas ? "1.70" : null}
                icon="fa fa-percent"
            />

            <CardResumo
                titulo="Clientes"
                loading={loading}
                valor={resumo.totalEntregas}
                icon="fa fa-users"
            />
        </div>
    );
}

function CardResumo({
    titulo,
    valor,
    loading = true,
    icon,
    destaque = false
}) {

    return (
        <div
            className={`
                rounded-2xl border p-4
                transition-all duration-200
                hover:shadow-soft hover:-translate-y-0.5
                cursor-default
                ${destaque
                    ? 'bg-primary/5 border-primary/20'
                    : 'bg-card border-border'}
            `}
        >

            <div className="flex items-start justify-between">

                <div>
                    <p className="
                        text-xs uppercase tracking-wide
                        text-muted-foreground font-medium
                    ">
                        {titulo}
                    </p>

                    {loading ? (
                        <Skeleton
                            width={80}
                            height={19.2}
                            className="mt-2"
                        />
                    ) : (
                        <h3
                            className={`
                                text-md font-bold font-display mt-2
                                ${destaque
                                    ? 'text-primary'
                                    : 'text-foreground'}
                            `}
                        >
                            {valor || "-"}
                        </h3>
                    )}
                </div>

                <div
                    className={`
                        h-10 w-10 rounded-xl
                        flex items-center justify-center
                        ${destaque
                            ? 'bg-primary/10 text-primary'
                            : 'bg-muted text-muted-foreground'}
                    `}
                >
                    <i className={icon}></i>
                </div>
            </div>
        </div>
    );
}

export default ResumoEscalas;
